import { jsonFetch } from "@/lib/helpers";
import { Customer } from "@/models/customer";
import { GET_CUSTOMER_BY_USER_ID } from "./api-url.constants";
import { CustomerApiDTO } from "./dtos";
import { mapperCustomerDTOtoCustomer } from "./mappers";

export const getCustomerByUserId = async (userId: string): Promise<Customer> => {
  const customerDTO = await jsonFetch<CustomerApiDTO>(`${GET_CUSTOMER_BY_USER_ID}/${userId}`);
  return mapperCustomerDTOtoCustomer(customerDTO.data);
};
